'use strict';
export default function routes($stateProvider) {
    'ngInject';
    $stateProvider.state('productDetail', {
        url: '/products/detail/:attributeText/:productName/:productId/:itemCode',
        template: require('./product-detail/template.html'),
        controller: 'ProductDetailController',
        controllerAs: 'vm',
        wireframeOptions: { headerClass: 'non-printable', footerClass: 'non-printable', bodyClass: 'product-details-page' }
    });
    //this is old stype route
    //exists here for backward compatibility
    $stateProvider.state('productDetailOld', {
        url: '/products/detail/:productId/item/:itemCode',
        template: require('./product-detail/template.html'),
        controller: 'ProductDetailController',
        controllerAs: 'vm',
        wireframeOptions: { headerClass: 'non-printable', footerClass: 'non-printable', bodyClass: 'product-details-page' }
    });
}
//# sourceMappingURL=products.routes.js.map